import { useContext } from 'react';
import { PRODUCT_NAME } from '../../assets/constants/brand';
import { TranslationContext } from '../../assets/contexts/translationContext';
import BankCard from '../BankCard/BankCard';
import './FullScreenSiteLoader.css';

function FullScreenSiteLoader({ isExiting = false }) {
  const { startup } = useContext(TranslationContext);
  const className = [
    'full-screen-site-loader',
    isExiting ? 'full-screen-site-loader--exiting' : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={className} aria-busy="true" aria-live="polite">
      <div className="full-screen-site-loader__scene" aria-hidden="true">
        <div className="full-screen-site-loader__cards">
          <BankCard
            cardStyle="aurora"
            size="onboardingBack"
            className="full-screen-site-loader__card full-screen-site-loader__card--back"
          />
          <BankCard
            cardStyle="lagoon"
            size="onboardingBack"
            className="full-screen-site-loader__card full-screen-site-loader__card--middle"
          />
          <BankCard
            cardStyle="sunset"
            size="onboardingFront"
            lastFour="8866"
            className="full-screen-site-loader__card full-screen-site-loader__card--front"
          />
        </div>
      </div>

      <div className="full-screen-site-loader__copy">
        <p className="full-screen-site-loader__eyebrow">{PRODUCT_NAME}</p>
        <h1 className="full-screen-site-loader__title">{startup.loaderTitle}</h1>
        <div className="full-screen-site-loader__progress" aria-label={startup.loaderTitle}>
          <span />
          <span />
          <span />
        </div>
      </div>
    </section>
  );
}

export default FullScreenSiteLoader;
